import { MouseEvent, useMemo } from 'react';

import { t } from '@lingui/macro';

import Loading from '@decisiv/ui-components/lib/components/Loading';
import Wizard from '@decisiv/ui-components/lib/components/Wizard';

import BulkCreateDepotProvider, {
  useBulkCreateDepotContext,
} from './context/BulkCreateDepotContext';
import StepOne from './StepOne';
import Summary from './Summary';

export interface BulkCreateDepotModalProps {
  onCancel: (event: MouseEvent<unknown> | KeyboardEvent) => void;
}

function BulkCreateDepotModal() {
  const { stepOneProps, wizardProps } = useBulkCreateDepotContext();

  const steps = useMemo(
    () => [
      {
        title: t`Bulk Create Depots`,
        content: <StepOne />,
        hideBodyTitle: true,
        intermediateContent: (
          <Loading
            size="small"
            title={t`Creating Depot(s)...`}
            description={t`Your Depots are being processed. Closing this window won't interrupt it. Results will be available when complete.`}
          />
        ),
        ...stepOneProps,
      },
      {
        title: t`Summary`,
        content: <Summary />,
        hideBodyTitle: true,
      },
    ],
    [stepOneProps],
  );

  return (
    <Wizard
      visible
      title={t`Bulk Create Depots`}
      steps={steps}
      {...wizardProps}
    />
  );
}

export default function BulkCreateDepotModalWrapper(
  props: BulkCreateDepotModalProps,
) {
  return (
    <BulkCreateDepotProvider onClose={props.onCancel}>
      <BulkCreateDepotModal />
    </BulkCreateDepotProvider>
  );
}
